import { createSelector } from 'reselect';

const selectUserDomain = (state) => state.get('user');

export const selectAppPending = createSelector(
  selectUserDomain,
  (state) => state.getIn(['ui', 'pending']),
);
